// extracted by mini-css-extract-plugin
export default {"item":"style_item__vLS2L","icon":"style_icon__ythNH","info":"style_info__SYKpe","bounce":"style_bounce__vt7fU"};